import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePromise } from "../../../Utils/usePromise";
import axios from "axios";
import Card from "reactstrap/es/Card";
import CardTitle from "reactstrap/es/CardTitle";
import Spinner from "reactstrap/es/Spinner";
import CardText from "reactstrap/es/CardText";
import numeral from 'numeral';
import 'numeral/locales/ru';
import { parseApiError } from "@yooink/youtils/es/ParseApiError";
export function OrdersCount({ from, to, type, title, color, typeCount = '', full }) {
    let url = 'general/orders';
    if (type === 'regular') {
        url = 'badges/orders/regularClients';
    }
    else if (type === 'new') {
        url = 'general/ordersFromNewCustomers';
    }
    else if (type === 'amo') {
        url = 'general/amocrmOrdersCount';
    }
    else if (type === 'base-promocode') {
        url = 'badges/orders/byPromocode/base';
    }
    else if (type === 'media-promocode') {
        url = 'badges/orders/byPromocode/media';
    }
    else if (type === 'no-promocode') {
        url = 'badges/orders/byPromocode/no';
    }
    else if (type === 'promocode') {
        url = 'badges/orders/byPromocode/any';
    }
    const { isLoading, isError, data = {}, errData } = usePromise(() => {
        return axios.get(`/api/v2/analytics/${url}`, { params: { from, to } })
            .then((res) => res.data);
    }, [from.getTime(), to.getTime()]);
    const { count, price } = data;
    return (_jsxs(Card, Object.assign({ body: true, className: color }, { children: [_jsx(CardTitle, { children: title }), isLoading && _jsx(Spinner, {}), !full && !isLoading && !isError && (_jsx("div", Object.assign({ className: "card_footer" }, { children: _jsx("div", Object.assign({ className: "count" }, { children: _jsxs("span", Object.assign({ className: "size-3" }, { children: [count, " ", typeCount] })) })) }))), full && !isLoading && !isError && (_jsxs("div", Object.assign({ className: "card_footer" }, { children: [_jsxs("div", Object.assign({ className: "count" }, { children: [_jsx("span", Object.assign({ className: "size-3" }, { children: count })), " \u0448\u0442."] })), _jsxs("div", Object.assign({ className: "price" }, { children: [_jsx("div", Object.assign({ className: "text" }, { children: "\u041D\u0430 \u0441\u0443\u043C\u043C\u0443" })), _jsxs("strong", { children: [numeral(price).format('0,0'), " \u20BD"] })] }))] }))), !isLoading && isError && (_jsx(CardText, { children: parseApiError(errData) }))] })));
}
